module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_3016.928dfd8e.png";